const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Border_box",
    "data-name": "Border box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    style: {
      fill: "none",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,23H3c-1.1,0-2-.9-2-2V3c0-1.1.9-2,2-2h18c1.1,0,2,.9,2,2v18c0,1.1-.9,2-2,2ZM6.6,17l2.28-9.97h-2.13l-.68,4.26c-.18,1.12-.34,2.32-.47,3.51h-.03c-.13-1.17-.34-2.4-.52-3.46l-.71-4.31h-2.15l2.23,9.97h2.18ZM12.52,6.91c-2.21,0-3.29,2.35-3.29,5.08s.89,5.14,3.15,5.14c1.89,0,3.23-1.52,3.23-5.28,0-2.28-.68-4.93-3.09-4.93ZM12.44,8.59c.87,0,1.14,1.58,1.14,3.33,0,2.03-.31,3.51-1.12,3.51s-1.21-1.15-1.21-3.42c0-2.15.43-3.42,1.2-3.42ZM21.43,15.22c-.24.07-.61.15-.93.15-1.18,0-2.09-.93-2.09-3.31s.99-3.42,2.09-3.42c.43,0,.68.09.9.19l.32-1.63c-.19-.13-.67-.27-1.35-.27-1.94,0-4.03,1.46-4.03,5.22,0,2.83,1.21,4.93,3.76,4.93.68,0,1.23-.1,1.51-.24l-.19-1.63Z",
    style: {
      fill: "currentColor",
      strokeWidth: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoc);
export default __webpack_public_path__ + "static/media/voc.bcb5adc1ed0f536244ccb3c37a476823.svg";
export { ForwardRef as ReactComponent };